import React from 'react';
const LogoUs = React.lazy(() => import('@stone/ui/logo/Logo_us'));
const LogoDefault = React.lazy(() => import('@stone/ui/logo/Logo_default'));
const Logo = (props) => {
    return window.country === 'US' || window.country === 'CA' ? React.createElement(LogoUs, Object.assign({}, props)) : React.createElement(LogoDefault, Object.assign({}, props));
};
export default Logo;
